import { models } from 'cesg-shared';
import { ProvisioningStatus } from 'cesg-shared/dist/models';

/**
 * Must track the server's `STALE_LEASE_WINDOW_MS` (`project-workspace-service.ts`). A run that has
 * held the lease longer than this is reclaimable there and offered a Retry here; there is no cron
 * to move it along (D2), so the two windows disagreeing would either hide a dead run or offer a
 * Retry the server refuses to honour.
 */
export const STALE_LEASE_WINDOW_MS = 10 * 60 * 1000;

export function isStaleInProgress(sharePoint: models.ProjectWorkspaceStatus | null): boolean {
  if (
    !sharePoint ||
    sharePoint.status !== ProvisioningStatus.IN_PROGRESS ||
    !sharePoint.startedAt
  ) {
    return false;
  }
  return Date.now() - new Date(sharePoint.startedAt).getTime() > STALE_LEASE_WINDOW_MS;
}

/** True while the server is expected to move this row on its own — the only reason to keep polling. */
export function isProvisioningActive(sharePoint: models.ProjectWorkspaceStatus | null): boolean {
  if (!sharePoint) return false;
  if (sharePoint.status === ProvisioningStatus.PENDING) return true;
  return sharePoint.status === ProvisioningStatus.IN_PROGRESS && !isStaleInProgress(sharePoint);
}
